
  export default {
    props: {
      fixed: {
        type: Boolean,
        default: false
      },
      transparency: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        itemsMenu: []
      }
    },
    mounted() { 
      window.addEventListener('scroll', this.handleScroll);
    },
    created() {
      this.itemsMenu = [
        {
          title: 'Portafolio',
          id: 'portfolio___es',
          route: ''
        },
        {
          title: 'Servicios',
          id: 'services___es',
          route: ''
        },
        {
          title: 'Sobre nosotros',
          id: 'aboutus___es',
          route: ''
        },
        {
          title: 'Contacto',
          id: 'contact___es',
          route: ''
        }
      ]
      this.itemsMenu.forEach(item => {
        const indice = this.$router.options.routes.find(route => route.name === item.id)
        if (indice) {
          item.route = indice.path
        }
      })
    },
    methods: {
      handleScroll() {
        const positionY = window.scrollY;
        if ( positionY > 400) {
          this.$el.classList.add('bg-70')
        } else {
          this.$el.classList.remove('bg-70')
        }
      }
    },
  }
